import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded } from 'react-redux-firebase';

import './CompanyTagManager.css';

import { toast } from 'react-toastify';
import LoadingSpinner from 'components/global/LoadingSpinner/LoadingSpinner';
import FormField from '../../contentform/FormField/FormField';

class CompanyTagManager extends React.Component {
  static propTypes = {
    industryTags: PropTypes.object,
    companies: PropTypes.array
  };

  state = {
    newTag: '',
    _tagsExpanded: {}
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleUploadTag = () => {
    const tagRef = `/tagCompanyIndustryIndex/${this.state.newTag}`;
    this.props.firebase.set(tagRef, true)
      .then(() => {
        toast.success('Tag successfully added');
        this.setState({ newTag: '' });
      })
      .catch((error) => toast.error('ERROR: ' + error.message));
  }

  handleDeleteTag = (tag) => {
    if (this._renderCompanyCount(tag) > 0) {
      toast.error('Error: Companies exist with tag. Please change the tag for these companies.');
    } else {
      const tagRef = `/tagCompanyIndustryIndex/${tag}`;
      this.props.firebase.remove(tagRef)
        .then(() => toast.success('Tag successfully deleted'))
        .catch((error) => toast.error('ERROR: ' + error.message));
    }
  }

  handleToggleTagExpand = (tag) => {
    const value = this.state._tagsExpanded[tag] !== undefined ? !this.state._tagsExpanded[tag] : true; 
    this.setState({ _tagsExpanded: { ...this.state._tagsExpanded, [tag]: value } });
  }

  _renderTagListItem = () => {
    const { industryTags } = this.props;

    return (
      Object.keys(industryTags).map(tag => (
        <div key={`tag-${tag}`} className='CompanyTagManager-tag'>
          <div className='CompanyTagManager-tag-title'>
            <div className='CompanyTagManager-tag-title-text' onClick={() => this.handleToggleTagExpand(tag)}>
              <h2>{tag}</h2>
              <p>Companies: {this._renderCompanyCount(tag)}</p>
            </div>
            <button className='CompanyTagManager-tag-delete' onClick={() => this.handleDeleteTag(tag)}>
              <i className='fa fa-trash-o' />
            </button>
          </div>
          {
            this.state._tagsExpanded[tag] &&
            <div className='CompanyTagManager-tag-companies'>
              {this._renderTaggedCompanies(tag)}
            </div>
          }
        </div>
      ))
    );
  }

  _renderCompanyCount = (tag) => {
    const { industryTags, companies } = this.props;
    if (tag === 'u') {
      let count = companies.length;
      Object.keys(industryTags).forEach(tag => {
        count -= this._renderCompanyCount(tag);
      });
      return count;
    }
    const filtered = companies.filter(company => company.value.industry === tag);
    return filtered.length;
  }

  _renderTaggedCompanies = (tag) => {
    const { industryTags, companies } = this.props;
    let filtered = [];
    if (tag === 'u') {
      companies.forEach(company => {
        if (Object.keys(industryTags).indexOf(company.value.industry) === -1) {
          filtered.push(company);
        }
      });
    } else {
      filtered = companies.filter(company => company.value.industry === tag);
    }
    return (
      filtered.map(company => (
        <Link key={`link-${company.key}`} to={`/companyform?company=${company.key}`}>
          <span>{company.value.name || 'Unnamed Company'}</span>
          <span> | {company.value.datePublished ? 'Published' : 'Draft'}</span>
        </Link>
      ))
    );
  }

  render() {
    const { industryTags, companies } = this.props;

    return (
      <div className='CompanyTagManager-root'>
        <FormField
          type='text'
          name='newTag'
          title=''
          subtitle='Add a new tag'
          value={this.state.newTag}
          buttonText='SUBMIT'
          buttonIcon='fa-upload'
          buttonDisabled={isLoaded(industryTags) && Object.keys(industryTags).indexOf(this.state.newTag) !== -1}
          errorCode={isLoaded(industryTags) && Object.keys(industryTags).indexOf(this.state.newTag) !== -1 ? 'duplicate-tag' : null}
          onChange={this.handleInputChange}
          onButtonClick={this.handleUploadTag}
        />
        {
          !isLoaded(industryTags) || !isLoaded(companies) ? 
          <div className='CompanyTagManager-loadingContainer'>
            <LoadingSpinner />
          </div> :
          <div className='CompanyTagManager-list'>
            {this._renderTagListItem()}
            {
              this._renderCompanyCount('u') > 0 &&
              <div className='CompanyTagManager-tag'>
                <div className='CompanyTagManager-tag-title'>
                  <div className='CompanyTagManager-tag-title-text' onClick={() => this.handleToggleTagExpand('u')}>
                    <h2 className='CompanyTagManager-tag-title-text-error'>Unknown</h2>
                    <p>Companies: {this._renderCompanyCount('u')}</p>
                  </div>
                  <button className='CompanyTagManager-tag-delete'>
                    <i className='fa fa-trash-o' />
                  </button>
                </div>
                {
                  this.state._tagsExpanded['u'] &&
                  <div className='CompanyTagManager-tag-companies'>
                    {this._renderTaggedCompanies('u')}
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

const connectedCompanyTagManager = connect(
  (state) => ({
    industryTags: state.firebase.data.tagCompanyIndustryIndex,
    companies: state.firebase.ordered.companyIndex
  })
)(CompanyTagManager);

const wrappedCompanyTagManager = firebaseConnect([
  { path: '/tagCompanyIndustryIndex' },
  { path: '/companyIndex' }
])(connectedCompanyTagManager);

export default wrappedCompanyTagManager;



// WEBPACK FOOTER //
// ./src/components/companies/CompanyTagManager/CompanyTagManager.js